import { useState } from 'react';
import { Radio, HelpCircle, Settings, Map } from 'lucide-react';
import AudioTab from '../components/ope/AudioTab';
import QuizTab from '../components/ope/QuizTab';
import OpeAdminTab from '../components/ope/OpeAdminTab';
import MapTab from '../components/ope/MapTab';
import { useAuth } from '../context/AuthContext';

const OpePage = () => {
    const [activeTab, setActiveTab] = useState('map');
    const { user } = useAuth();
    const isAdmin = user?.role === 'admin';

    return (
        <div className="p-4 md:p-6 mb-20 md:mb-0 space-y-6 max-w-7xl mx-auto">
            {/* Header */}
            <div className="flex flex-col gap-2">
                <h1 className="text-2xl font-bold text-[var(--text-primary)] flex items-center gap-3">
                    <span className="p-2 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg text-white">
                        🎓
                    </span>
                    Estudio OPE
                </h1>
                <p className="text-[var(--text-muted)]">
                    Prepárate para la OPE con audios del temario y test tipo examen.
                </p>
            </div>

            {/* Tabs */}
            <div className="flex p-1 bg-[var(--glass-bg)] rounded-xl backdrop-blur-sm border border-[var(--glass-border)]">
                <button
                    onClick={() => setActiveTab('audio')}
                    className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-medium transition-all duration-200
            ${activeTab === 'audio'
                            ? 'bg-indigo-600 text-white shadow-lg'
                            : 'text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--glass-bg)]'
                        }`}
                >
                    <Radio className="w-4 h-4" />
                    Temario Audio
                </button>
                <button
                    onClick={() => setActiveTab('quiz')}
                    className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-medium transition-all duration-200
            ${activeTab === 'quiz'
                            ? 'bg-purple-600 text-white shadow-lg'
                            : 'text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--glass-bg)]'
                        }`}
                >
                    <HelpCircle className="w-4 h-4" />
                    Test & Quizzes
                </button>
                {isAdmin && (
                    <button
                        onClick={() => setActiveTab('admin')}
                        className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-medium transition-all duration-200
                ${activeTab === 'admin'
                                ? 'bg-amber-600 text-white shadow-lg'
                                : 'text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--glass-bg)]'
                            }`}
                    >
                        <Settings className="w-4 h-4" />
                        Admin
                    </button>
                )}
                <button
                    onClick={() => setActiveTab('map')}
                    className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-medium transition-all duration-200
            ${activeTab === 'map'
                            ? 'bg-emerald-600 text-white shadow-lg'
                            : 'text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--glass-bg)]'
                        }`}
                >
                    <Map className="w-4 h-4" />
                    Simulador Rutas
                </button>
            </div>

            {/* Content Area */}
            <div className="bg-[var(--bg-secondary)] rounded-2xl border border-[var(--glass-border)] p-4 md:p-6 min-h-[400px]">
                {activeTab === 'audio' ? (
                    <AudioTab />
                ) : activeTab === 'quiz' ? (
                    <QuizTab />
                ) : activeTab === 'admin' && isAdmin ? (
                    <OpeAdminTab />
                ) : activeTab === 'map' ? (
                    <MapTab />
                ) : null}
            </div>
        </div>
    );
};

export default OpePage;
